"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOG_LEVEL = void 0;
exports.LOG_LEVEL = {
    ERROR: 'ERROR',
    INFO: 'INFO',
    WARN: 'WARN'
};
//# sourceMappingURL=logLevel.js.map